<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-card outlined>
                <v-card-subtitle>Informe</v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <p class="font-weight-medium">
                        Genera un informe en PDF con los datos de este parte
                      </p>
                      <v-btn
                        color="primary"
                        outlined
                        @click="guardarYGenerarPDF()"
                        :loading="generandoInforme"
                        :disabled="guardadoDeshabilitado || parte.bloqueado"
                      >
                        <v-icon>
                          mdi-file-document-outline
                        </v-icon>
                        Generar PDF
                      </v-btn>
                      <v-checkbox
                        class="mb-2"
                        hide-details
                        label="No mostrar horas ponderadas"
                        v-model="ocultarHorasPonderadas"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-card outlined>
                <v-card-subtitle>Comunicaciones</v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-row>
                        <v-col>
                          <p class="font-weight-medium">
                            Envía el parte por correo a los contactos asignados al cliente
                          </p>
                          <v-alert
                            dense
                            outlined
                            border="left"
                            type="info"
                            icon="mdi-information-outline"
                            v-if="!existenContactos && !cargandoContactos"
                          >
                            Este cliente no tiene contactos informados. Para poder enviar las comunicaciones, es necesario asignarle contactos desde BC
                          </v-alert>
                          <v-alert
                            dense
                            outlined
                            border="left"
                            type="info"
                            icon="mdi-information-outline"
                            v-if="existenContactos && !cargandoContactos && !hayContactosSeleccionados"
                          >
                            Debes indicar al menos un contacto para poder enviar la comunicación.
                          </v-alert>
                          <v-autocomplete
                            v-model="contactosSeleccionados"
                            :items="contactos"
                            chips
                            label="Contactos"
                            multiple
                            deletable-chips
                            :loading="cargandoContactos"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-autocomplete
                            v-model="contactosCC"
                            :items="contactosCC"
                            chips
                            deletable-chips
                            label="Con copia a"
                            multiple
                            :disabled="!parte.esEditable"
                            maxlength="0"
                          ></v-autocomplete>
                          <v-text-field
                            label="Introducir email Cc"
                            v-model="contactoCC"
                            v-on:keyup.enter="addContactoCC()"
                            @input="$v.contactoCC.$touch()"
                            @blur="$v.contactoCC.$touch()"
                            :error-messages="errorContactoCC"
                            class="anadirAsterisco"
                            :disabled="!parte.esEditable"
                          ></v-text-field>
                          <v-btn
                            color="primary"
                            outlined
                            @click="addContactoCC()"
                            :disabled="guardadoDeshabilitado || parte.bloqueado || !existenContactos || $v.contactoCC.$invalid || !parte.esEditable"
                          >
                            Añadir
                          </v-btn>
                          <v-checkbox
                            class="mb-2"
                            hide-details
                            label="No mostrar horas ponderadas"
                            v-model="ocultarHorasPonderadas"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-toolbar flat>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          outlined
                          @click="guardarYEnviar()"
                          :loading="enviandoInforme"
                          :disabled="guardadoDeshabilitado || parte.bloqueado || !existenContactos || !parte.esEditable || !hayContactosSeleccionados"
                        >
                          <v-icon>
                            mdi-email-send-outline
                          </v-icon>
                          Enviar
                        </v-btn>
                      </v-toolbar>
                    </v-col>
                  </v-row>
                </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-card outlined>
                <v-card-subtitle>Registro de comunicaciones</v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-data-table
                          :headers="headersRegistrosComunicaciones"
                          :items="parte.registros_comunicaciones"
                          :items-per-page="5"
                          sort-by="created_at"
                          sort-desc
                      >
                          <template v-slot:item.user="{ item }">
                              <v-chip outlined>
                                  <v-avatar left :color="item.user.color">
                                      <span class="white--text">
                                          {{ item.user.avatar }}
                                      </span>
                                  </v-avatar>
                                  {{ item.user.name+' '+item.user.apellidos}}
                              </v-chip>
                          </template>
                          <template v-slot:item.created_at="{ item }">
                              {{ formatearFecha(item.created_at) }}
                          </template>
                           <template v-slot:item.estado="{ item }">
                              <v-chip
                                :color="item.estado == 'success' || item.estado == 'error' ? item.estado 
                                          : 'info'"
                                outlined
                                pill
                                small
                              >
                                  {{ 
                                    item.estado == 'success' ? 'Enviado' 
                                      : item.estado == 'error' ? 'Error'
                                        : 'Pendiente'
                                  }}
                              </v-chip>
                          </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card> 
  </div>
</template>

<script>
  import axios from "axios";
  import { required, email } from "vuelidate/lib/validators";
  import { mapActions, mapState } from 'vuex';
  import formatearFecha from '../../mixins/formatearFecha';
  import Echo from "laravel-echo";
  // import io from "socket.io-client";
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;

  export default {
    name: "InformeComunicaciones",
    props: ["parte", "guardadoDeshabilitado"],
    mixins: [formatearFecha],
    data() {
      return {
        cargandoContactos: false,
        generandoInforme: false,
        enviandoInforme: false,
        contactos: [],
        contactosSeleccionados: [],
        contactoCC: '',
        contactosCC: [],
        ocultarHorasPonderadas: false,
        headersRegistrosComunicaciones: [
          {
            text: 'Usuario',
            align: 'start',
            sortable: true,
            value: 'user'
          },
          {
            text: 'Fecha',
            align: 'start',
            sortable: true,
            value: 'created_at'
          },
          {
            text: 'Estado',
            align: 'center',
            sortable: false,
            value: 'estado'
          },
        ]
      };
    },
    validations: {
      contactoCC: { required, email },
    },
    methods: {
      ...mapActions(['setLoading', 'setSnackbar']),
      ...mapActions({
        guardarParte: 'acciones/guardarParte'
      }),
      async guardarYGenerarPDF(){
        this.generandoInforme = true;
        try {
          const materialesRequest = await this.$store.dispatch('materiales/getMaterialesRequest');
          this.parte.materiales = materialesRequest;
          let params = {
            ocultarHorasPonderadas: this.ocultarHorasPonderadas
          }
          await this.guardarParte()
          let respuesta = await axios({
            method: 'get',
            url: `/api/informeParte/${this.parte.id}`,
            params: params,
            responseType: 'blob'
          });
          let url = window.URL.createObjectURL(new Blob([respuesta.data]));
          let link = document.createElement('a');
          link.href = url;
          let filename = 'parte-'+this.parte.numParte+'.pdf';
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          this.generandoInforme = false;
          link.click();
          this.setSnackbar({
            tipo: 'success',
            mensaje: 'El informe está listo para su descarga'
          });
        }catch (error){
          this.generandoInforme = false;
          console.log(error);
          this.setSnackbar({
            tipo: 'error',
            mensaje: 'Error. No se ha podido generar el informe'
          });
        }
      },
      async guardarYEnviar(){
        this.enviandoInforme = true;
        this.$v.contactoCC.$reset();
        try{
          const materialesRequest = await this.$store.dispatch('materiales/getMaterialesRequest');
          this.parte.materiales = materialesRequest;
          await this.guardarParte()
          try{
            // Enviar mail
            let params = {
              contactos: this.contactosSeleccionados,
              contactosCC: this.contactosCC,
              ocultarHorasPonderadas: this.ocultarHorasPonderadas
            }
            let respuesta = await axios.post(`/api/comunicacionesParte/${this.parte.id}`, params);
            let comunicacionId = respuesta.data;
            this.setSnackbar({
              tipo: 'info',
              mensaje: 'Mail añadido a la cola correctamente.'
              // mensaje: 'Parte enviado correctamente'
            });
            // Añadir registro (solo visual, luego la api lo inserta en la BBDD de manera independiente)
            console.log(this.parte.registros_comunicaciones);
            this.parte.registros_comunicaciones.push({
              id: comunicacionId,
              created_at: new Date(),
              user: {
                name: this.authUser.name,
                apellidos: this.authUser.apellidos,
                color: this.authUser.color,
                avatar: this.authUser.avatar
              },
              estado: 'pendiente'
            });
          }catch (error){
            this.setSnackbar({
              tipo: 'error',
              mensaje: 'Error. No se ha podido enviar el informe'
            });
          }
          this.enviandoInforme = false;
        }catch (error){
          this.enviandoInforme = false;
          this.setSnackbar({
            tipo: 'error',
            mensaje: 'Error. No se ha podido enviar el informe'
          });
        }
        console.log('enviar');
      },
      addContactoCC(){
        if (this.$v.contactoCC.$dirty) {
          if (!this.$v.contactoCC.$invalid && !this.contactosCC.includes(this.contactoCC)) {
            this.contactosCC.push(this.contactoCC);
            this.$v.contactoCC.$reset();
            this.contactoCC = '';
          }
        }
      }
    },
    computed: {
      ...mapState("login", ["authUser"]),
      hayContactosSeleccionados(){
        if(this.contactosSeleccionados.length > 0 || this.contactosCC.length > 0){
          return true;
        }
        return false;
      },
      existenContactos(){
        if(this.contactos.length > 0){
          return true;
        }
        return false;
      },
      errorContactoCC() {
        if (this.contactoCC.length > 0 && this.$v.contactoCC.$dirty) {
          if (this.$v.contactoCC.$invalid) {
            return "Introduce una dirección de correo válida";
          }
        }
      }
    },
    async mounted() {
      this.cargandoContactos = true;
      try{
        let respuesta = await axios.get(`/api/comunicacionesParte/${this.parte.cliente_id}`);
        this.cargandoContactos = false;
        this.contactos = respuesta.data;
        this.contactosSeleccionados = this.contactos;
      }catch (error){
        this.cargandoContactos = false;
        console.log(error);
        this.setSnackbar({
          tipo: 'error',
          mensaje: 'Error. No se han podido obtener los contactos del cliente'
        });
      };
      // window.io = io;
      // window.Echo = new Echo({
      //   broadcaster: "socket.io",
      //   host: process.env.VUE_APP_SOCKET_IO,
      // });
      // window.Echo.channel("ardipartes_database_channel-comunicaciones").listen("ActualizarRegistroComunicaciones", (data) => {
      //     console.log("--------->");
      //     console.log(data);
      //     this.parte.registros_comunicaciones.map(registro => {
      //       if(registro.id === data.id) {
      //         registro.estado = data.estado
      //       }
      //     })
      //   }
      // );
    },
    destroyed() {
      console.log('Destroyed informe comunicaciones');
      // window.Echo.leave("ardipartes_database_channel-comunicaciones");
    }
  };
</script>